import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator  } from "firebase/auth"; // Facoltativo: Se usi Firebase Authentication
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore"; // Facoltativo: Se usi Firestore
import { getStorage, connectStorageEmulator } from "firebase/storage"; // Facoltativo: Se usi Firebase Storage

const firebaseConfig = {
  apiKey: "AIzaSyA6KY3GANh9TmPiW4nayClpOy5PCbopnuk",
  authDomain: "magical-beach-5c274.firebaseapp.com",
  projectId: "magical-beach-5c274",
  storageBucket: "magical-beach-5c274.firebasestorage.app",
  messagingSenderId: "266605761541",
  appId: "1:266605761541:web:af601e8673fad2896bb86c",
  measurementId: "G-78NCTG83QL"
};

const app = initializeApp(firebaseConfig);

// Esporta i servizi che ti servono
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);

